import { useEffect, useState } from "react";
import { Link } from "./LocaleLink";
import { useLang } from "../context/LanguageContext";
import { applyConsent, readConsent, saveConsent } from "../lib/consent";

// Minimal, premium consent banner: analytics (GA4 + Clarity) only after an explicit choice. Re-openable from the footer.
export const CookieConsent = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const stored = readConsent();
    if (!stored) setOpen(true);
    else if (!stored.analytics) applyConsent(false);
    const show = () => setOpen(true);
    window.addEventListener("vl-consent-open", show);
    return () => window.removeEventListener("vl-consent-open", show);
  }, []);

  if (!open) return null;
  const choose = (analytics) => { saveConsent(analytics); setOpen(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookies.title")}
      data-testid="cookie-consent"
      className="fixed inset-x-4 bottom-4 sm:inset-x-auto sm:left-6 sm:bottom-6 sm:max-w-md z-[60] border border-primary/40 bg-background/95 backdrop-blur-md shadow-2xl p-6"
    >
      <p className="font-accent text-[10px] uppercase tracking-[0.3em] text-primary">{t("cookies.title")}</p>
      <p className="mt-3 font-body font-light text-sm text-foreground/80 leading-relaxed">
        {t("cookies.text")}{" "}
        <Link to="/mentions-legales" className="underline decoration-primary/40 underline-offset-4 hover:text-primary" data-testid="cookie-consent-policy">
          {t("cookies.more")}
        </Link>
      </p>
      <div className="mt-5 flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={() => choose(true)}
          data-testid="cookie-consent-accept"
          className="flex-1 bg-primary text-primary-foreground hover:bg-primary/90 px-5 py-3 font-accent text-[11px] uppercase tracking-[0.2em] transition-colors"
        >
          {t("cookies.accept")}
        </button>
        <button
          type="button"
          onClick={() => choose(false)}
          data-testid="cookie-consent-reject"
          className="flex-1 border border-foreground/30 text-foreground hover:border-primary hover:text-primary px-5 py-3 font-accent text-[11px] uppercase tracking-[0.2em] transition-colors"
        >
          {t("cookies.reject")}
        </button>
      </div>
    </div>
  );
};
